export abstract class ServiceRedirectPort {
  abstract goToProducts(): void;
  abstract goToServiceConfiguration(): void;
  abstract goToInfoService(): void;
}
